import ChipColors from './ChipColors';

export default [
  {
    text: 'Inativo',
    value: 'Inactive',
    ...ChipColors.neutral,
  },
  {
    value: 'RequestedDelete',
    text: 'Deleção Requisitada',
    ...ChipColors.danger,
  },
  // {
  //   value: 'InAnalysisValidation',
  //   text: 'Análise de validação',
  //   position: 2,
  //   ...ChipColors.wait,
  // },
  {
    text: 'Ativo',
    value: 'Active',
    ...ChipColors.success,
  },
  // {
  //   text: 'Temporariamente bloqueado',
  //   value: 'TempBlocked',
  //   ...ChipColors.danger,
  // },
  // {
  //   value: 'PermBlocked',
  //   text: 'Permanentemente bloqueado',
  //   ...ChipColors.warning,
  // },
];
